import { render, staticRenderFns } from "./FileManager.vue?vue&type=template&id=71195430&scoped=true&"
import script from "./FileManager.vue?vue&type=script&lang=ts&"
export * from "./FileManager.vue?vue&type=script&lang=ts&"
import style0 from "./FileManager.vue?vue&type=style&index=0&id=71195430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71195430",
  null
  
)

export default component.exports